import { WHITELABEL_EVENT_KEY } from 'components/constants/Constants';

// We re-export some variables here because they are guaranteed defined inside this directory.

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const UXB_EVENT_KEY = WHITELABEL_EVENT_KEY!;
